import React, { createContext, useContext, useEffect, useRef, useState } from "react";

const NavContext = createContext(null);

/**
 * headerMode:
 * - "top"    — at page top, transparent menu
 * - "hidden" — scrolling down, menu slides away
 * - "pinned" — scrolling up, white sticky menu pulls down
 */
export function NavProvider({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [headerMode, setHeaderMode] = useState("top");
  const lastY = useRef(0);

  useEffect(() => {
    lastY.current = window.scrollY;

    const onScroll = () => {
      const y = window.scrollY;
      const delta = y - lastY.current;

      if (y < 80) {
        setHeaderMode("top");
      } else if (delta > 4) {
        setHeaderMode("hidden");
      } else if (delta < -4) {
        setHeaderMode("pinned");
      }

      lastY.current = y;
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("locked", mobileOpen);
    return () => document.body.classList.remove("locked");
  }, [mobileOpen]);

  const value = {
    mobileOpen,
    openMobile: () => setMobileOpen(true),
    closeMobile: () => setMobileOpen(false),
    toggleMobile: () => setMobileOpen((v) => !v),
    headerMode,
  };

  return <NavContext.Provider value={value}>{children}</NavContext.Provider>;
}

export function useNav() {
  const ctx = useContext(NavContext);
  if (!ctx) throw new Error("useNav must be used within NavProvider");
  return ctx;
}
